export type ExecuteSyncOperationSuccess = {
  status: 'Success'
  [key: string]: any
}
